import { render } from "./TurtleForm.vue?vue&type=template&id=a44302e6"
import script from "./TurtleForm.vue?vue&type=script&lang=js"
export * from "./TurtleForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__